import React from "react";
import { Exercise } from "../../../models/Exercise";
import "../style.scss";
import "../../../../style/block.scss";
import "../../../../style/hovers.scss";
import { BsArrowRight, BsCircle } from "react-icons/bs";
import { BiBlock } from "react-icons/bi";
import { useTranslation } from "react-i18next";
import { Identifiable } from "../../../models/Identifiable";
import EATooltip from "../../shared/EATooltip/EATooltip";
import ExerciseSlotLabel, { slotIsAvailable } from "./ExerciseSlotLabel";
import { useCalendarExerciseChoice } from "./useCalendarExerciseChoice";

interface IProps {
  exercise: Exercise[];
  getTicketsByExercise: (id: Identifiable, exercises: Exercise) => void;
  handleWhichClicked: (index: number) => void;
  handleCloseModal?: (boolean: boolean) => void;
  getDetailsAboutClickedExercise: (exerciseId: number) => void;
  whichClicked: number;
  onTimeSelect?: () => void;
}

const CalendarExerciseChoice: React.FC<IProps> = ({
  getDetailsAboutClickedExercise,
  exercise,
  getTicketsByExercise,
  handleCloseModal,
  handleWhichClicked,
  whichClicked,
  onTimeSelect,
}) => {
  const { t } = useTranslation();
  const { showTimeOfEntance, showTicketsPool, getQntStateCount, handleTimeSelection } =
    useCalendarExerciseChoice({
      getDetailsAboutClickedExercise,
      getTicketsByExercise,
      handleCloseModal,
      handleWhichClicked,
      onTimeSelect,
    });

  if (!exercise || exercise.length === 0) {
    return <div className="no-available-exercises">{t("Brak dostępnych godzin")}</div>;
  }

  return (
    <>
      {exercise.map((item, index) => {
        const available = slotIsAvailable(item);
        const ticketCount = getQntStateCount(String(item.objectId));
        const rowClass =
          index === whichClicked
            ? "active-hour-single hour-single flex-between-center flex-center-center flex-wrap move-up"
            : "hour-single flex-between-center flex-center-center flex-wrap move-up";

        const label = (
          <ExerciseSlotLabel
            item={item}
            showEndTime={showTimeOfEntance}
            showTicketsPool={showTicketsPool}
            variant={available ? "available" : "soldOut"}
            selectedInBasket={ticketCount}
          />
        );

        if (available) {
          return (
            <button
              type="button"
              key={item.objectId ?? index}
              className={rowClass}
              onClick={() => handleTimeSelection(index, item.objectId, item.exerciseGroup, item)}
            >
              {index === whichClicked ? <BsArrowRight className="icon" /> : <BsCircle className="icon" />}
              {label}
            </button>
          );
        }

        return (
          <div key={item.objectId ?? index} className="calendar-sale-exercise-choice-soldout">
            <EATooltip content={t("wszystkie_bilety_zostaly_sprzedane")} position="right">
              <div className="hour-single-disable hour-single flex-between-center flex-center-center flex-wrap">
                <BiBlock className="icon" />
                {label}
              </div>
            </EATooltip>
          </div>
        );
      })}
    </>
  );
};

export default CalendarExerciseChoice;
